import Form from '../../common/form';
import Joi from 'joi';

import { func } from 'prop-types';

class ETWallThicknessItemForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		flangeWidth: Joi.number().positive().required().label('Flange Width (mm)'),
		flangeThickness: Joi.number()
			.positive()
			.required()
			.label('Flange Thickness (mm)'),
		webLength: Joi.number().positive().required().label('Web Length (mm)'),
		webThickness: Joi.number()
			.positive()
			.required()
			.label('Web Thickness (mm)'),
		diameter: Joi.number().required().label('Diameter (inches)'),
	};

	static propTypes = {
		onAdd: func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'flangeWidth',
							type: 'number',
							label: 'Flange Width (mm)',
							placeholder: 'Enter Flange Width (mm)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							name: 'flangeThickness',
							type: 'number',
							label: 'Flange Thickness (mm)',
							placeholder: 'Enter Flange Thickness (mm)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'webLength',
							label: 'Web Length (mm)',
							placeholder: 'Enter Web Length (mm)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'webThickness',
							label: 'Web Thickness (mm)',
							placeholder: 'Enter Web Thickness (mm)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'diameter',
							label: 'Diameter (inches)',
							placeholder: 'Enter Diameter (inches)',
						})}
					</div>
				</div>

				{this.renderButton('Add Item')}
			</form>
		);
	}
}

export default ETWallThicknessItemForm;

const initialData = {
	flangeWidth: 0,
	flangeThickness: 0,
	webLength: 0,
	webThickness: 0,
	diameter: 0,
};
